import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { StorefrontIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, EnabledTransactionTypesPill, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import { deliveryMethodIcons } from './constants'
import { getCarriersInfo, getStoreNames } from './helpers'
import * as Styles from './styles'

const UnifiedDeliveryMethodInfo = ({ deliveryMethod }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { info } = useContext(AppContext)

  return (
    <Styles.Container>
      <Styles.InfoContainer>
        {deliveryMethodIcons[deliveryMethod?.type]}
        <Text type="titleS" tag="label">
          {deliveryMethod?.internal_name}
        </Text>
        <Styles.CarriersLogosContainer>
          {getCarriersInfo(deliveryMethod)
            .slice(0, 3)
            .map((carrier, index) => (
              <Styles.CarrierLogo key={index} src={carrier.logo_url} alt={carrier.name} />
            ))}
          {getCarriersInfo(deliveryMethod).length > 3 && (
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {t('y más')}
            </Text>
          )}
        </Styles.CarriersLogosContainer>
      </Styles.InfoContainer>
      <Styles.ChipsContainer>
        <EnabledTransactionTypesPill
          refund={deliveryMethod?.enabled_for_refunds}
          exchange={deliveryMethod?.enabled_for_exchanges}
          mixed={deliveryMethod?.enabled_for_mixed}
        />
        <Tooltip title={getStoreNames(info?.stores, deliveryMethod).join(', ')} arrow position="bottom">
          <Chip
            color={theme.colors.danger.onSurface}
            backgroundColor={theme.colors.danger.surface}
            size={24}
            Icon={StorefrontIcon}
            label={`${deliveryMethod?.store_ids?.length} ${deliveryMethod?.store_ids?.length > 1 ? t('tiendas') : t('tienda')}`}
          />
        </Tooltip>
      </Styles.ChipsContainer>
    </Styles.Container>
  )
}

export default UnifiedDeliveryMethodInfo
